import React from 'react';

// tslint:disable:max-line-length
const ClockIcon = (props) => (
  <svg width={1920} height={1920} viewBox="0 0 1920 1920" {...props}>
    <g fill={props.color || 'currentColor'} fillRule="evenodd">
      <path d="M960 1920C429.807 1920 0 1490.193 0 960S429.807 0 960 0s960 429.807 960 960-429.807 960-960 960zm0-240c397.645 0 720-322.355 720-720s-322.355-720-720-720-720 322.355-720 720 322.355 720 720 720z" />
      <rect x={840} y={360} width={240} height={720} rx={120} />
      <path d="M706.836 1247.203c-57.395 33.136-130.788 13.468-163.923-43.924-33.137-57.395-13.473-130.785 43.923-163.923l311.77-180c57.395-33.137 130.787-13.468 163.922 43.923 33.137 57.395 13.474 130.785-43.922 163.923l-311.77 180z" />
    </g>
  </svg>
);
// tslint:enable:max-line-length

export default ClockIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/ClockIcon.js